export default {
  watch: {
    '$i18n.locale' () {
      this.$nextTick(() => {
        Object.values(this.$refs).forEach(reference => {
          const forms = Array.isArray(reference) ? reference : [reference]
          forms.forEach(form => {
            if (!form || !Array.isArray(form.fields) || !form.validateField) return
            form.fields.filter(field => field.validateState === 'error' && field.prop)
              .forEach(field => form.validateField(field.prop, () => {}))
          })
        })
      })
    }
  }
}
